import React, { useState } from 'react';
import { useSearchParams, useNavigate } from "react-router-dom";
import API from "../../api/Createapi";
import "./Resetpasswordpage.css";
import "../login/Loginpage.css"; // Shared auth styles
import { FaLock, FaEye, FaEyeSlash, FaCheckCircle, FaShieldAlt, FaKey } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../Loader';
import logo from "../../Assets/ritu broadband.png";

function Resetpasswordpage() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== confirmPassword) {
            toast.error("Passwords do not match!");
            return;
        }

        if (password.length < 6) {
            toast.error("Password must be at least 6 characters long.");
            return;
        }

        setLoading(true);

        try {
            const res = await API.post("/reset_password.php", {
                token,
                password
            });

            if (res.data.status === "success") {
                toast.success("Password updated successfully! Redirecting to login...");
                setTimeout(() => navigate("/login"), 2000);
            } else {
                toast.error(res.data.message || "Invalid or expired reset link.");
            }
        } catch (err) {
            console.error(err);
            toast.error("Server error while resetting password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page-wrapper">
            {loading && <Loader />}

            <div className="auth-card reset-card">
                {/* Hero Side */}
                <div className="auth-hero-banner">
                    <div className="auth-hero-glow auth-glow-1"></div>
                    <div className="auth-hero-glow auth-glow-2"></div>
                    
                    <div className="auth-hero-content">
                        <div className="auth-brand-text-logo">
                            RiTU <span>BROADBAND</span>
                        </div>
                        
                        <h2 className="auth-hero-title">Reset Your Password</h2>
                        <p className="auth-hero-desc">
                            Set up a strong, new password to keep your Ritu Broadband account safe.
                        </p>

                        <div className="auth-features-list">
                            <div className="auth-feature-item">
                                <div className="auth-feature-icon"><FaShieldAlt /></div>
                                <span>High Grade Data Protection</span>
                            </div>
                            <div className="auth-feature-item">
                                <div className="auth-feature-icon"><FaKey /></div>
                                <span>Instant Security Activation</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Form Panel */}
                <div className="auth-form-panel">
                    <div className="auth-header">
                        <h2>New Password</h2>
                        <p>Create a strong password of at least 6 characters</p>
                    </div>

                    <form onSubmit={handleSubmit} className="auth-form">
                        <div className="input-group">
                            <label htmlFor="newPassword">New Password</label>
                            <div className="input-field-wrapper">
                                <span className="input-field-icon"><FaLock /></span>
                                <input
                                    id="newPassword"
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter new password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                <span
                                    className="password-toggle-btn"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>

                        <div className="input-group">
                            <label htmlFor="confirmNewPassword">Confirm New Password</label>
                            <div className="input-field-wrapper">
                                <span className="input-field-icon"><FaLock /></span>
                                <input
                                    id="confirmNewPassword"
                                    type={showConfirmPassword ? "text" : "password"}
                                    placeholder="Confirm new password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                                <span
                                    className="password-toggle-btn"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                >
                                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>
                        </div>

                        <button type="submit" className="auth-submit-btn" disabled={loading}>
                            {loading ? "Updating..." : <><FaCheckCircle /> Update Password</>}
                        </button>
                    </form>

                    <div className="auth-footer-prompt">
                        <p>
                            Already updated?{" "}
                            <span className="auth-action-link" onClick={() => navigate("/login")}>
                                Sign In
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    );
}

export default Resetpasswordpage;